import { useTranslation } from "react-i18next";
import { useEffect, useMemo, useState } from "react";
import { Spacer, PageDS, ToastContainerDS, TabMenu } from "@qivia/ui";
import { useNavigate, useParams } from "react-router-dom";
import { useAppSelector } from "../../redux/hooks";
import { selectAdminUser } from "../homeSlice";
import { SepaDirectDebitTab } from "./sepaDirectDebit";
import { MemobankMandatesTab } from "./memoBankMandates/memobankMandates";
import { SepaDirectDebitHistoryTab } from "./sepaDirectDebitHistoryTab";
import { SepaDirectDebitReturnedTab } from "./sepaDirectDebitReturnedTab";
import "../../i18n/i18n";

export const MandatesAndSepaDirectDebits = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const params = useParams();
  const [selectedTab, setSelectedTab] = useState<string>(
    params.tab ?? "memobankMandates",
  );
  const adminUser = useAppSelector(selectAdminUser);

  useEffect(() => {
    if (selectedTab) {
      navigate(
        `/home/mandates_and_sepa_direct_debits/${selectedTab}${
          params.id !== undefined ? `/${params.id}` : ""
        }`,
      );
    }
  }, [navigate, params.id, selectedTab]);

  const tabs = useMemo(() => {
    const tabs = [];

    if (adminUser?.email !== "exterieur1@qivia.fr") {
      tabs.push({
        name: "memobankMandates",
        title: t("mandatesAndSepaDirectDebits.tab.memobankMandates"),
      });

      tabs.push({
        name: "sepaDirectDebit",
        title: t("mandatesAndSepaDirectDebits.tab.sepaDirectDebit"),
      });
    }

    tabs.push({
      name: "sepaDirectDebitHistory",
      title: t("mandatesAndSepaDirectDebits.tab.sepaDirectDebitHistory"),
    });

    tabs.push({
      name: "sepaDirectDebitReturned",
      title: t("mandatesAndSepaDirectDebits.tab.sepaDirectDebitReturned"),
    });

    return tabs;
  }, [adminUser?.email, t]);

  return (
    <PageDS
      title={t(`mandatesAndSepaDirectDebits.${params.tab}`)}
      toaster={<ToastContainerDS />}
      topElement={
        <>
          <Spacer y={1} />
          <TabMenu
            tabs={tabs}
            selectedTab={selectedTab}
            setSelectedTab={setSelectedTab}
          />
        </>
      }
    >
      <SepaDirectDebitTab />
      <MemobankMandatesTab />
      <SepaDirectDebitHistoryTab />
      <SepaDirectDebitReturnedTab />
    </PageDS>
  );
};
